// src/config/routes.js

export const ROUTES = {
    home: {
      en: 'https://fermedebasseilles.be/en/home/',
      fr: 'https://fermedebasseilles.be/',
      nl: 'https://fermedebasseilles.be/nl/thuis/'
    },
    tinyHouse: {
      en: 'https://fermedebasseilles.be/en/discover-our-unusual-accommodations/',
      fr: 'https://fermedebasseilles.be/decouvrez-nos-logements-insolites/',
      nl: 'https://fermedebasseilles.be/nl/ontdek-onze-ongewone-accommodaties/'
    },
    bnb: {
      en: 'https://fermedebasseilles.be/en/discover-our-cottages-guest-rooms/',
      fr: 'https://fermedebasseilles.be/decouvrez-nos-gites-amp-chambres-dhotes/',
      nl: 'https://fermedebasseilles.be/nl/ontdek-onze-gites-gastenkamers/'
    },
    extras: {
      en: 'https://fermedebasseilles.be/en/extras-2/',
      fr: 'https://fermedebasseilles.be/extras/',
      nl: 'https://fermedebasseilles.be/nl/aanvullingen/'
    },
    activity: {
      en: 'https://fermedebasseilles.be/en/activities-partners/',
      fr: 'https://fermedebasseilles.be/activites-partenaires/',
      nl: 'https://fermedebasseilles.be/nl/activiteiten-partners/'
    },
    whoAreWe: {
      en: 'https://fermedebasseilles.be/en/who-are-we/',
      fr: 'https://fermedebasseilles.be/qui-sommes-nous/',
      nl: 'https://fermedebasseilles.be/nl/wie-zijn-wij/'
    },
    news: {
      en: 'https://fermedebasseilles.be/en/news-press/',
      fr: 'https://fermedebasseilles.be/info-presse/',
      nl: 'https://fermedebasseilles.be/nl/info-pers/'
    },
    // New entry will go here
    giftCard: {
      fr: 'https://fermedebasseilles.be/bon-cadeau/',
      en: 'https://fermedebasseilles.be/en/gift-voucher/',
      nl: 'https://fermedebasseilles.be/nl/cadeaubon/'
    }
};